import type { ExerciseLogsRecord } from '@/types/collections'

export type DashboardSummary = {
  greeting: string
  timestamp: string
  upcomingEventsCount: number
  pendingHomeworkCount: number
  recentWorkoutsCount: number
  latestGrades: Array<unknown>
}

export type QuickStats = {
  upcomingEvents: number
  pendingAssignments: number
  monthlyExerciseMinutes: number
  lastUpdated: string
}

export function sumExerciseMinutes(logs: Array<Partial<ExerciseLogsRecord>>): number {
  return logs.reduce((sum, log) => sum + (typeof log.duration === 'number' ? log.duration : 0), 0)
}

export function buildDashboardSummary(input: {
  upcomingEventsCount: number
  pendingHomeworkCount: number
  recentWorkoutsCount: number
  recentGrades: Array<unknown>
  greeting?: string
  timestamp?: string
}): DashboardSummary {
  return {
    greeting: input.greeting || 'Welcome to Clarix',
    timestamp: input.timestamp || new Date().toISOString(),
    upcomingEventsCount: input.upcomingEventsCount,
    pendingHomeworkCount: input.pendingHomeworkCount,
    recentWorkoutsCount: input.recentWorkoutsCount,
    latestGrades: input.recentGrades.slice(0, 3),
  }
}

export function buildQuickStats(input: {
  upcomingEventsCount: number
  pendingAssignmentsCount: number
  exerciseLogs: Array<Partial<ExerciseLogsRecord>>
  lastUpdated?: string
}): QuickStats {
  return {
    upcomingEvents: input.upcomingEventsCount,
    pendingAssignments: input.pendingAssignmentsCount,
    monthlyExerciseMinutes: sumExerciseMinutes(input.exerciseLogs),
    lastUpdated: input.lastUpdated || new Date().toISOString(),
  }
}
